<template>
  <div class="system-param">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>系统参数维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='mini'  @click="syspainsert">新增</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="parname"
          label="参数名称">
        </el-table-column>
        <el-table-column
          prop="parameter"
          label="数值">
        </el-table-column>
        <el-table-column
          prop="unit"
          label="单位"
          v-if="true">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类别"
          v-if="false">
        </el-table-column>

        <el-table-column
          width="150"
          label="操作">
          <template slot-scope="scope">     

            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="SyspaEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.id"
              type="text"
              size="small"
              v-if="false"
              @click="SyspaDelete(scope.row.id)">
              删除
            </el-button>            
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @current-change="changePage">
      </el-pagination>

      <el-dialog title="新增系统参数" :visible.sync="syspaIsVisible" @close="closeSyspaInsertDialog">
        <el-form :model="syspaForm" label-position="right">
          <el-form-item label="参数名称">
            <el-input v-model="syspaForm.parname" autocomplete="off" placeholder="例如：系统链接有效时间"></el-input>
          </el-form-item>        
          <el-form-item label="参数值">
            <el-input v-model="syspaForm.parameter" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="单位">
            <el-input v-model="syspaForm.unit" autocomplete="off"></el-input>
          </el-form-item>        
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeSyspaInsertDialog">取消</el-button>
          <el-button type="primary" @click="confirmSyspaInsertDialog">确定</el-button>
        </div>
      </el-dialog>

      <SyspaEditDialog
        :dialog-visible="SyspaEditIsVisible"
        :dialog-data="currentDataId"
        @ok="confirmSyspaEditDialog"
        @close="closeSyspaEditDialog">
      </SyspaEditDialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SyspaEditDialog from './SyspaEditDialog.vue';

export default {
  name: 'SystemParam',
  components: {
    SyspaEditDialog,
  },
  data() {
    return {
      searchParams: {
        startTime: '',
        endTime: '',
      },
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      syspaIsVisible: false,
      syspaForm: {
        parname:'',
        parameter:'',
        unit: '',   
      },
      //修改窗口：参数
      SyspaEditIsVisible:false,
      currentDataId: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      axios.post('/iapi/syspam', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    syspainsert(){
      this.syspaIsVisible = true;
      this.syspaForm.parname = '';
      this.syspaForm.parameter = '';
      this.syspaForm.unit = '';
    },
    SyspaEdit(dataId) {
      // console.log('行数据在这里！',dataId);
      this.currentDataId =  dataId;
      this.SyspaEditIsVisible = true;      
    },
    closeSyspaInsertDialog() {
      // console.log('取消');
      this.syspaIsVisible = false;
    },
    confirmSyspaInsertDialog(){
      this.closeSyspaInsertDialog();
      // console.log('param',this.syspaForm);
      const params = {
        ...this.syspaForm,
      }
      axios.post('/iapi/syspainsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新增系统参数成功！');
        }
      });
      this.getData();
    },
    closeSyspaEditDialog() {
      // console.log('取消');
      this.SyspaEditIsVisible = false;
    },

    confirmSyspaEditDialog(data) {
      // console.log('编辑确定在这里', data);
      this.closeSyspaEditDialog();
      const params = {
        id:data.id,
        parname:data.parname,
        parameter:data.parameter,
        unit:data.unit,
      }
      axios.post('/iapi/syspaedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑系统参数信息成功！');
        }
      });
      this.getData();
    },
  },
};
</script>

<style scoped>

.system-param {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>